module.exports = __webpack_public_path__ + "img/invite-case02.02b33d68.jpeg";